import Payment from 'payment';

function InputCardNumber() {
  const self = this;

  self.init = function init(element) {
    const $el = $(element);

    if ($el.data('app-module-initialized')) return; // Prevent double init

    const $field = $el.find('.js-input-card-number__field');

    function checkType() {
      const type = Payment.fns.cardType($field.val());
      $el.attr('data-card-type', type);
    }

    checkType();

    $field.on('input change', checkType);

    $el.data('app-module-initialized', true);
  };

  self.initAll = function initAll() {
    $('.js-input-card-number').each(function init() {
      self.init(this);
    });
  };
}

export default new InputCardNumber();
